var variants = {
  'horizontal-small': 'style_horizontal-small__yi75sw1 style__yi75sw0',
  'horizontal-large': 'style_horizontal-large__yi75sw2 style__yi75sw0',
  'vertical-small': 'style_vertical-small__yi75sw3'
};
export { variants };
